import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"


export function Contact() {

  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Ready to get started on your project? </p>
        <p>Contact me now for a Free consultation.</p>
      </header>
      <div className="contacts">
        <div>
          <a href={`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}`}><img src={emailIcon} alt="Email" /></a>
          <a href={`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}`}>{process.env.REACT_APP_EMAIL_ADDRESS}</a>
        </div>
        <div>
          <a href={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}><img src={phoneIcon} alt="Phone No" /></a>
          <a href={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}>{process.env.REACT_APP_PHONE_NUMBER}</a>
        </div>
      </div>
    </Container>
  )
}